<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: ['options','height','data'],
  methods: {
    newData: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.count,
            fill: true,
            backgroundColor: "#44c7ff",
            label: ""
          }
        ]},
        {
          responsive: true,
          // maintainAspectRatio: false,
          legend: {
            display: false
          },
          title: {
            display: true,
            fontSize: 20,
            text: 'Types de fureteur'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            yAxes: [{
              stacked: true
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Usagers'
              },
              stacked: true
            }]
          },
          animation: {
            duration: 500,
          },
        }
      )
    }
  },
  computed: {
    sortedData: function() {
      var output = Object.entries(this.data).map(([key, value]) => ({key,value}));
      return output.sort((a,b) => (a.value < b.value) ? 1 : -1)
      // return this.data.slice().sort((a,b) => (a.editCount < b.editCount) ? 1 : -1)
      //   .slice(1,16)
    },
    labels: function() {
      let result = [];
      for(var value of this.sortedData) {
        result.push(value.key);
      }
      return result;
    },
    // datasets
    count: function() {
      let result = [];
      for(var value of this.sortedData) {
        result.push(value.value);
      }
      return result;
    }
  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
    // this.renderChart(this.chartdata, this.options)
    // this.renderChart({data: [10,14,15]}, this.options)
  }
}
</script>
